/** The product's name and wordmark: identical in every language, so they are constants, not catalog text. */
export const BRAND_NAME = "FinancialHarmony"
export const BRAND_WORDMARK = "Harmony"
